<div>
    <kendo-gridlayout [rows]="[{height:38}]"
                      [cols]="[{width:255},{width:60}]"
                      [gap]="{cols: 5}">

        <kendo-gridlayout-item [row]="1" [col]="1" [colSpan]="1">
            <kendo-textbox [(ngModel)]="urlControl.value"></kendo-textbox>
        </kendo-gridlayout-item>
        <kendo-gridlayout-item [row]="1" [col]="2" [colSpan]="1">
            <button kendoButton (click)="launch()" themeColor="tertiary">
                <fa-icon [icon]="icon"></fa-icon>
                {{ "general.launch" | translate }}
            </button>
        </kendo-gridlayout-item>

    </kendo-gridlayout>
</div>
